import { ElearningDataType } from '../elearning';
import CommentsType from '../comments';

export enum ReviewerStatus {
  NOT_STARTED = 0,
  IN_PROGRESS = 1,
  COMPLETED = 2,
}
export interface ReviewerMetadata {
  firstName: string;
  lastName: string;
  email: string;
}

export interface ReviewerType {
  id: string;
  name: string;
  tenantId?: string;
  lcmsReferenceIds?: any;
  isDeleted?: boolean | null;
  createdAt?: Date;
  modifiedAt?: Date;

  reviewerMetadata: ReviewerMetadata;

  elearning?: ElearningDataType;
  message: string;
  status: ReviewerStatus;
  tmsUserId: number;
  tmsReviewerUserId: number;
  lastAccessed: Date;
  comments: CommentsType[];
}
